import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

export default function RegistrationPending() {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card shadow-sm text-center" style={{ maxWidth: 480 }}>
        <div className="card-body p-5">
          <Clock size={48} className="text-warning mb-3" />
          <h4 className="fw-bold mb-2">Application Received</h4>
          <p className="text-muted">
            Thank you for applying for a wholesale account. Our team will review your
            application and contact you within 1–2 business days.
          </p>
          <Link to="/login" className="btn btn-outline-secondary mt-2">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
